import React from "react";
import { useNavigate } from "react-router-dom";
import { ModuleI } from "../types";

interface ToolboxTopNavigationProps {
  topic: ModuleI;
  fromUrl: string;
  lessonTitle?: string;
}

const ToolboxTopNavigation: React.FC<ToolboxTopNavigationProps> = ({
  topic,
  fromUrl,
  lessonTitle,
}) => {
  const navigate = useNavigate();

  const isFromLesson = fromUrl.includes("/sections/");
  const isFromTopicOnly = fromUrl.includes("/topics/") && !isFromLesson;

  const handleExploreClick = () => {
    navigate("/explore");
  };

  const handleTopicTitleClick = () => {
    navigate(`/topics/${topic.slug ?? topic._id}`);
  };

  const handleReturnToSection = () => {
    navigate(fromUrl);
  };

  return (
    <div className="w-screen bg-white border-b border-gray-200 shadow-sm">
      <div className="w-full max-w-none px-4 py-3">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-3xl mx-auto">
          {/* Breadcrumb Navigation */}
          <div className="flex items-center text-sm sm:text-base text-gray-700 flex-wrap gap-1 justify-center">
            <span
              className="cursor-pointer hover:text-electrum transition-colors underline"
              onClick={handleExploreClick}
            >
              Explore
            </span>
            <span className="text-gray-400">›</span>
            {isFromLesson && lessonTitle ? (
              <>
                <span
                  className="cursor-pointer hover:text-electrum transition-colors underline"
                  onClick={handleTopicTitleClick}
                >
                  {topic.title}
                </span>
                <span className="text-gray-400">›</span>
                <span
                  className="cursor-pointer hover:text-electrum transition-colors underline"
                  onClick={handleReturnToSection}
                >
                  {lessonTitle}
                </span>
                <span className="text-gray-400">›</span>
                <span className="font-semibold underline">Toolbox</span>
              </>
            ) : isFromTopicOnly ? (
              <>
                <span
                  className="cursor-pointer hover:text-electrum transition-colors underline"
                  onClick={handleReturnToSection}
                >
                  {topic.title}
                </span>
                <span className="text-gray-400">›</span>
                <span className="font-semibold underline">Toolbox</span>
              </>
            ) : (
              <>
                <span
                  className="cursor-pointer hover:text-electrum transition-colors underline"
                  onClick={handleTopicTitleClick}
                >
                  {topic.title}
                </span>
                <span className="text-gray-400">›</span>
                <span className="font-semibold underline">Toolbox</span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolboxTopNavigation;
